import { Button } from "antd";
import styled, { createGlobalStyle } from "styled-components";

export const containerStyle = {
  width: "100%",
  height: "100%",
};

export const MapFocusReset = createGlobalStyle`
  #map-print,
  #map-print-area {
    user-select: none;
  }

  #map-print:focus,
  #map-print:focus-visible,
  #map-print-area:focus,
  #map-print-area:focus-visible,
  #map-print .gm-style:focus,
  #map-print .gm-style:focus-visible,
  #map-print .gm-style div:focus,
  #map-print .gm-style div:focus-visible,
  #map-print [tabindex]:focus,
  #map-print [tabindex]:focus-visible {
    outline: none !important;
    box-shadow: none !important;
  }

  #map-print .gm-style > iframe + div {
    border: none !important;
    opacity: 0 !important;
  }
`;

export const MarkersContainer = styled.div`
  pointer-events: none;
  z-index: 1000000;

  & > .marker-text {
    margin-left: 10px;
  }
`;

export const ContextMenu = styled.div`
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  padding: 8px 0;
  z-index: 1000;
  min-width: 200px;
  pointer-events: auto;
`;

export const ContextMenuItem = styled.button`
  display: flex;
  align-items: center;
  width: 100%;
  gap: 12px;
  padding: 12px 16px;
  cursor: pointer;
  font-size: 14px;
  color: #424242;
  transition: background 0.2s ease;

  &:hover {
    background: #fff;
    color: #40a9ff;
    border-color: #40a9ff;
  }

  :disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }
`;
export const StyledButton = styled(Button)`
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
`;
